import React from 'react';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { SearchContentProps } from '@jbhi-fi/components/src/Contentful/transformers/SearchContentTransformer';

const SearchContentResult = ({
  searchResults,
  searchTerm,
}: {
  searchResults: Array<SearchContentProps>;
  searchTerm: string;
}) => {
  if (searchResults?.length) {
    return (
      <div className="search-content-container">
        <div className="search-content-inner-container">
          <DomFont className="search-content-title">Explore {searchTerm}</DomFont>
          <div className="search-content-hits">
            {searchResults.map((result: SearchContentProps, i: number) => {
              const { title, image, url, destination } = result;
              if (!title || !image) {
                return null;
              }
              return (
                <div className="search-content-cell" key={`search-content-${i}`} data-testid="search-content-cell">
                  <a href={url || destination}>
                    {image ? <div className="search-content-image-container">{image}</div> : null}
                    <span className="search-content-cell-text">{title}</span>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default SearchContentResult;
